import axios from 'axios'
import Swal from 'sweetalert2'


export default function onSubmitBiodata(user, setEditBiodata, setBiodata, setDisabled, province, districts) {
    Swal.showLoading()
    const token = localStorage.getItem('token');
    let biodata = user
    let updateBiodata = {
        gender: biodata.gender,
        birth_place: biodata.birth_place,
        birth_date: biodata.birth_date,
        address: biodata.address,
        kecamatan: biodata.kecamatan,
        kelurahan: biodata.kelurahan,
        kodepos: biodata.kodepos,
        provinsi: province.iso,
        kabupaten: districts.code
    }
    var config = {
        method: 'post',
        url: `${process.env.REACT_APP_API}/participant/profile/update/biodata`,
        headers: { token: token },
        data: {
            biodata: updateBiodata
        }
    };

    axios(config)
        .then(function (response) {
            setEditBiodata(false)
            setDisabled(true)
            setBiodata(response.data)
            Swal.close()
        })
        .catch(function (error) {
            console.log(error);
        });
}